module.exports = __webpack_public_path__ + "static/media/Rectangle 556.a8c558c7.svg";